module.exports = __webpack_public_path__ + "img/basics7.636b3b33.png";